import MomentUtils from '@date-io/moment';
import { Button } from '@material-ui/core';
import { DatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  ALL_STATUS_COLOR,
  DASHBOARD_REST_VIEW,
  DATE_FORMAT,
  DISPLAY_DATE_FORMAT,
  REST_STATUS_DROPDOWN,
} from '../../../../constants/DashboardConst';
import CustomCalendarView from '../../../../shared/dashboard/custom-calendar-view/Custom-Calendar-View';
import CustomStatusList from '../../../../shared/dashboard/custom-status-list/Custom-Status-List';
import { dashboardSelectedRestaurantSelector } from '../../../property/propertySlice';
import {
  dashboardCalendarTypeSelector,
  dashboardFilterDateSelector,
  restaurantDashboardReservationsSelector,
  setDashboardFilterDate,
} from '../../DashboardSlice';
import './DashboardRestaurantReservations.scss';

const DashboardRestaurantReservations = (props) => {
  const { onViewToggle, obj } = props;
  const [selectedValue, setSelectedValue] = useState('');
  const dispatch = useDispatch();
  const currSelectedRest = useSelector(dashboardSelectedRestaurantSelector);
  const calendarRef = useRef();
  const allDashboardRestList = useSelector(restaurantDashboardReservationsSelector);
  const date = useSelector(dashboardFilterDateSelector);
  const calendarType = useSelector(dashboardCalendarTypeSelector);
  const [restReservation, setRestReservation] = useState({
    filterList: [],
    eventList: [],
  });

  const filteredList = (dateObj, dashboardRestList, type) => {
    let appointmentDate = moment(dashboardRestList.date, DATE_FORMAT);
    if (type === 'timeGridDay') {
      const currentDate = moment(dateObj.formatDate, DATE_FORMAT).format('YYYY-MM-DD');
      appointmentDate = moment(dashboardRestList.date, DATE_FORMAT).format('YYYY-MM-DD');
      if (currentDate === appointmentDate) return true;
    } else if (type === 'timeGridWeek') {
      const startDate = moment(dateObj.startDate, DATE_FORMAT);
      const endDate = moment(dateObj.formatDate, DATE_FORMAT);
      if (startDate.isSameOrBefore(appointmentDate) && endDate.isSameOrAfter(appointmentDate))
        return true;
    } else {
      const currentYearMonth = moment(dateObj.formatDate, DATE_FORMAT);
      if (
        currentYearMonth.isSame(appointmentDate, 'month') &&
        currentYearMonth.isSame(appointmentDate, 'year')
      )
        return true;
    }
  };

  const onChangeDate = (selectedDate, status) => {
    const currentDate = { ...date };
    if (calendarType === 'timeGridWeek') {
      const startDate = moment(selectedDate).startOf('week').format(DISPLAY_DATE_FORMAT);
      const endDate = moment(selectedDate).endOf('week').format(DISPLAY_DATE_FORMAT);
      currentDate.displayDate = `${startDate} to ${endDate}`;
      currentDate.formatDate = moment(endDate, DISPLAY_DATE_FORMAT).format(DATE_FORMAT);
    } else {
      currentDate.displayDate = moment(selectedDate).format(
        calendarType === 'timeGridDay' ? DISPLAY_DATE_FORMAT : 'MMM',
      );
      currentDate.formatDate = moment(selectedDate).format(DATE_FORMAT);
    }
    dispatch(setDashboardFilterDate(currentDate));
    if (calendarRef?.current && calendarRef?.current?.getApi())
      calendarRef?.current?.getApi()?.gotoDate(moment(currentDate.formatDate).format(DATE_FORMAT));
    filterEvent(currentDate, status, calendarType);
  };

  const filterEvent = (dateObj, status, type) => {
    const filterList = allDashboardRestList.filter((dashboardRestList) => {
      if (dashboardRestList.restaurantId === currSelectedRest.id && status === 'All')
        return filteredList(dateObj, dashboardRestList, type);
      if (
        dashboardRestList.restaurantId === currSelectedRest.id &&
        dashboardRestList.status === status
      )
        return filteredList(dateObj, dashboardRestList, type);
      return false;
    });
    const eventList = filterList?.map((dashboardRestList) => {
      const appointmentDate = moment(dashboardRestList.date, DATE_FORMAT).format('YYYY-MM-DD');
      const start = `${appointmentDate}T${dashboardRestList.reserveFrom}`;
      const end = `${appointmentDate}T${dashboardRestList.reserveUntil}`;
      const getColor = ALL_STATUS_COLOR.find(
        (statusColor) => statusColor.id === dashboardRestList.status,
      );
      return {
        title: dashboardRestList.exposure,
        start,
        end,
        extendedProps: {
          type: 'restaurant',
          sideColor: getColor?.color,
          backgroundColor: getColor?.backGroundColor,
          status: getColor?.id,
          guestNo: dashboardRestList.noOfGuests,
          name: dashboardRestList.firstName + ' ' + dashboardRestList.lastName,
          table:
            dashboardRestList.tableNumbers.length > 0
              ? 'Table No: ' + dashboardRestList.tableNumbers[0]
              : '',
          appointmentDate,
        },
      };
    });
    setRestReservation({ filterList, eventList });
  };

  const handleStatusChange = (e) => {
    setSelectedValue(e);
    filterEvent(date, e, calendarType);
  };

  useEffect(() => {
    onChangeDate(moment(), 'All');
    setSelectedValue('All');
  }, []);

  const renderInput = (textFieldProps) => (
    <Button
      variant='outlined'
      color='secondary'
      size='small'
      endIcon={<KeyboardArrowDownIcon />}
      onClick={() => textFieldProps.onClick()}
      className='me-2 date-view'
    >
      {moment(date.formatDate, DATE_FORMAT).format('MMM YYYY')}
    </Button>
  );

  const onClickBack = () => {
    const viewType = obj?.id ? DASHBOARD_REST_VIEW : null;
    const viewStatus = obj?.id ? true : false;
    const viewObj = obj?.id ? obj : null;
    return onViewToggle(viewType, viewStatus, viewObj);
  };

  return (
    <div className='rest-dashboard-appointment-view container px-3 mt-4 mb-3 detail-view-65 pb-4'>
      <div className='mt-5 row mx-0 align-items-center'>
        <div className='col-md-1'>
          <Button
            variant='text'
            color='secondary'
            size='large'
            startIcon={<ArrowBackIcon fontSize='medium' />}
            className='me-2'
            onClick={() => onClickBack()}
          >
            Back
          </Button>
        </div>
        <div className='col-md-8'>
          <h3>{'Reservations'}</h3>
        </div>
        <div className='col-md-3 d-flex justify-content-end'>
          <MuiPickersUtilsProvider utils={MomentUtils}>
            <DatePicker
              autoOk
              variant='dialog'
              value={moment(date.formatDate, DATE_FORMAT)}
              onChange={(date) => onChangeDate(date, selectedValue)}
              TextFieldComponent={renderInput}
              animateYearScrolling
              DialogProps={{ className: 'date-picker-dashboard-dialog' }}
            />
          </MuiPickersUtilsProvider>
        </div>
      </div>
      <div className='mt-4 card shadow'>
        <div className='row'>
          <div className='col-md-4'>
            <CustomStatusList
              dropdownList={REST_STATUS_DROPDOWN}
              filterList={restReservation.filterList}
              idType='restaurantId'
              countType='bookings'
              name='firstName'
              duration='scheduledTime'
              selectedValue={selectedValue}
              handleStatusChange={handleStatusChange}
            />
          </div>
          <div className='col-md-1 line' />
          <div className='col-md-7'>
            <CustomCalendarView
              date={date}
              calendarType={calendarType}
              calendarRef={calendarRef}
              events={restReservation.eventList}
              filterEvent={filterEvent}
              selectedValue={selectedValue}
              countTitle='Bookings'
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardRestaurantReservations;
